import React from 'react';
import { connect } from 'react-redux';
import { changeLoginId } from '../../../redux/userAuthentication/userAuth.actions';
import { onLoginEnter } from '../../../utils/commonFunctions';

const mapStateToProps = (state) => {
	return {
		loginId: state.rootReducer.loginDetails.loginId,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onNameChange: (name) => dispatch(changeLoginId(name)),
	};
};

const LoginForm = ({ loginId, onNameChange, placeholder }) => (
	<div>
		<input
			aria-label="email/phone"
			type="text"
			name="txtLoginId"
			onKeyDown={onLoginEnter}
			id="txtLoginId"
			className="step-username-field aadhaar_number input-text"
			placeholder={placeholder || 'Email / Phone no'}
			value={loginId}
			onChange={(e) => onNameChange(e.target.value)}
		/>
	</div>
);

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
